import { PageHeader } from "@shared/components/PageHeader";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import { useState } from "react";

export default function RiskParameterTab({ data }: { data: any }) {
  const [selectedParameter, setSelectedParameter] = useState<string | null>(
    null
  );

  // Ensure criticalityAssessment is always an array
  const riskParameters: any[] = Array.isArray(
    data?.result?.criticalityAssessment
  )
    ? data.result.criticalityAssessment
    : [];

  const getScoreColor = (score: number) => {
    if (score >= 4) return "text-green-600";
    if (score >= 3) return "text-yellow-600";
    return "text-red-600";
  };

  if (riskParameters.length === 0) {
    return (
      <Card>
        <PageHeader
          title="System Risk Assessment Parameters"
          subtitle="Detailed breakdown of risk assessment factors for this system"
        />
        <CardContent className="mt-3">
          <div className="text-center py-8 text-gray-500">
            No risk parameters data available
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <PageHeader
          title="System Risk Assessment Parameters"
          subtitle="Detailed breakdown of risk assessment factors for this system"
        />
      <CardContent>
        {riskParameters.map((param: any) => (
          <div
            key={param.name}
            onClick={() =>
              setSelectedParameter(
                selectedParameter === param.name ? null : param.name
              )
            }
            className="p-3 border rounded-lg cursor-pointer mb-2 hover:bg-gray-50"
          >
            <div className="flex justify-between items-center">
              <span className="font-medium">{param.name}</span>
              <Badge>{param.weight}% Weight</Badge>
            </div>

            <div className="flex items-center justify-between mt-2">
              <span className={`${getScoreColor(param.score)} font-semibold`}>
                {param.score}/5
              </span>
              <span className="text-sm text-gray-500">Score</span>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
